export class ApiError extends Error {
  constructor(message, data, status, description, requestUrl, traceId) {
    super(message)

    this.data = data
    this.status = status
    this.description = description
    this.requestUrl = requestUrl
    this.traceId = traceId
  }
}

export const post = (url, data, token, failOnError = true) =>
  fetch(url, {
    method: 'POST',
    body: data ? JSON.stringify(data) : null,
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      ...((token && { Authorization: `Bearer ${token}` }) || {}),
    },
  }).then(response => {
    if (failOnError && !response.ok) {
      return response.json().then(json => {
        throw new ApiError(
          json?.message,
          json,
          response.status,
          null,
          url,
          json.traceId,
        )
      })
    }
    return response.json()
  })

export const put = (url, data, token, failOnError = true) =>
  fetch(url, {
    method: 'PUT',
    body: JSON.stringify(data),
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      ...((token && { Authorization: `Bearer ${token}` }) || {}),
    },
  }).then(response => {
    if (failOnError && !response.ok) {
      return response.json().then(json => {
        throw new ApiError(
          json?.message,
          json,
          response.status,
          null,
          url,
          json.traceId,
        )
      })
    }
    return response.json()
  })

export const get = (url, token, failOnError = true) =>
  fetch(url, {
    method: 'GET',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : null),
    },
  }).then(response => {
    if (failOnError && !response.ok) {
      return response.json().then(json => {
        throw new ApiError(
          json?.message,
          json,
          response.status,
          null,
          url,
          json.traceId,
        )
      })
    }
    return response.json()
  })

export const apiDelete = (url, token, failOnError = true) =>
  fetch(url, {
    method: 'DELETE',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : null),
    },
  }).then(response => {
    if (failOnError && !response.ok) {
      return response.json().then(json => {
        throw new ApiError(
          json?.message,
          json,
          response.status,
          null,
          url,
          json.traceId,
        )
      })
    }
    return response.json()
  })
